import { WSTable } from "@wingspanhq/fe-component-library";
import { PayableRow } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { getColumns } from "./columns";

type Props = {
  items: PayableRow[];
  loading?: boolean;
  dateField: "due" | "paid";
  onRowClick?: (item: PayableRow) => void;
};

// Pure table: props in, no fetching, no root margin — the section wrapper
// (ClientPayablesList.tsx) owns the query, pagination, and spacing.
export const ClientPayablesTable: React.FC<Props> = props => {
  const tableData = useMemo(
    () => props.items.map(item => ({ id: item.id as string, data: item })),
    [props.items]
  );
  const columns = useMemo(
    () => getColumns({ dateField: props.dateField }),
    [props.dateField]
  );

  return (
    <WSTable<PayableRow>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      onRowClick={
        props.onRowClick ? item => props.onRowClick!(item.data) : undefined
      }
    />
  );
};
